// src/pages/Invite.js

import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getUserSettings, getWallet } from "../firebase";
import {
  FaGift,
  FaCopy,
  FaWhatsapp,
  FaUserFriends,
  FaWallet,
} from "react-icons/fa";
import { AiOutlineLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import "../styles/invite.css";

export default function Invite() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [wallet, setWallet] = useState(null);

  useEffect(() => {
    if (!user) return;

    const load = async () => {
      const u = await getUserSettings(user.uid);
      const w = await getWallet(user.uid);

      setUserData(u);
      setWallet(w);
    };

    load();
  }, [user]);

  if (!userData) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  const referralLink = `${window.location.origin}/?ref=${userData.referralCode}`;

  const copyCode = async () => {
    await navigator.clipboard.writeText(userData.referralCode);
    alert("Referral code copied!");
  };

  const copyLink = async () => {
    await navigator.clipboard.writeText(referralLink);
    alert("Referral link copied!");
  };

  const shareWhatsapp = () => {
    const text = `🎉 Join me on Eyal App!

Install Eyal App using my referral link and earn exciting rewards.

${referralLink}`;

    window.open(
      `https://wa.me/?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  return (
    <div className="invite-page">

      {/* Back */}

      <button className="back-btn" onClick={() => navigate(-1)}>
        <AiOutlineLeft /> Back
      </button>

      {/* Hero */}

      <div className="invite-hero">
        <FaGift size={42} />

        <h2>Invite Friends & Earn</h2>

        <p>
          Earn <strong>₹5</strong> for every successful referral.
        </p>
      </div>

      {/* Referral Code */}

      <div className="invite-card">

        <h3>Your Referral Code</h3>

        <div className="invite-code">
          {userData.referralCode}
        </div>

        <button onClick={copyCode}>
          <FaCopy /> Copy Code
        </button>

      </div>

      {/* Referral Link */}

      <div className="invite-card">

        <h3>Your Referral Link</h3>

        <div className="invite-link">
          {referralLink}
        </div>

        <button onClick={copyLink}>
          <FaCopy /> Copy Link
        </button>

      </div>

      {/* Share */}

      <button
        className="wa-btn"
        onClick={shareWhatsapp}
      >
        <FaWhatsapp />
        Share on WhatsApp
      </button>

      {/* Stats */}

      <div className="stats-row">

        <div className="stat-card">
          <FaUserFriends size={30} />
          <h2>{userData.referralCount || 0}</h2>
          <p>Friends Joined</p>
        </div>

        <div className="stat-card">
          <FaWallet size={30} />
          <h2>₹{wallet?.totalEarned || 0}</h2>
          <p>Total Earned</p>
        </div>

      </div>

      {/* Terms */}

      <div className="invite-card">

        <h3>Referral Terms</h3>

        <ul className="terms">

          <li>Earn ₹5 for every successful referral.</li>

          <li>Rewards are credited only once per referred user.</li>

          <li>Self referrals are not allowed.</li>

          <li>Fake or duplicate accounts are not eligible.</li>

          <li>Eyal reserves the right to modify the referral program.</li>

        </ul>

      </div>

    </div>
  );
}